import script from "./CustomFileUploadInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFileUploadInput.vue?vue&type=script&setup=true&lang=js"

import "./CustomFileUploadInput.vue?vue&type=style&index=0&id=6ae93118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae93118"]])

export default __exports__